import { render, staticRenderFns } from "./auditTable.vue?vue&type=template&id=5c91efb2&scoped=true"
import script from "./auditTable.vue?vue&type=script&lang=js"
export * from "./auditTable.vue?vue&type=script&lang=js"
import style0 from "./auditTable.vue?vue&type=style&index=0&id=5c91efb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91efb2",
  null
  
)

export default component.exports